/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterCorporateAddPost } from '../fn/corporate/api-master-corporate-add-post';
import { ApiMasterCorporateAddPost$Params } from '../fn/corporate/api-master-corporate-add-post';
import { apiMasterCorporateDeleteGet } from '../fn/corporate/api-master-corporate-delete-get';
import { ApiMasterCorporateDeleteGet$Params } from '../fn/corporate/api-master-corporate-delete-get';
import { apiMasterCorporateEditPost } from '../fn/corporate/api-master-corporate-edit-post';
import { ApiMasterCorporateEditPost$Params } from '../fn/corporate/api-master-corporate-edit-post';
import { apiMasterCorporateGetActiveGet } from '../fn/corporate/api-master-corporate-get-active-get';
import { ApiMasterCorporateGetActiveGet$Params } from '../fn/corporate/api-master-corporate-get-active-get';
import { apiMasterCorporateGetAllGet } from '../fn/corporate/api-master-corporate-get-all-get';
import { ApiMasterCorporateGetAllGet$Params } from '../fn/corporate/api-master-corporate-get-all-get';
import { apiMasterCorporateGetByCriteriaPost } from '../fn/corporate/api-master-corporate-get-by-criteria-post';
import { ApiMasterCorporateGetByCriteriaPost$Params } from '../fn/corporate/api-master-corporate-get-by-criteria-post';
import { Corporate } from '../models/corporate';
import { CorporateApiRespModel } from '../models/corporate-api-resp-model';
import { Int32ApiRespModel } from '../models/int-32-api-resp-model';

@Injectable({ providedIn: 'root' })
export class CorporateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterCorporateAddPost()` */
  static readonly ApiMasterCorporateAddPostPath = '/api/Master/Corporate/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateAddPost$Response(params?: ApiMasterCorporateAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateApiRespModel>> {
    return apiMasterCorporateAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateAddPost(params?: ApiMasterCorporateAddPost$Params, context?: HttpContext): Observable<CorporateApiRespModel> {
    return this.apiMasterCorporateAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateApiRespModel>): CorporateApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCorporateEditPost()` */
  static readonly ApiMasterCorporateEditPostPath = '/api/Master/Corporate/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateEditPost$Response(params?: ApiMasterCorporateEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CorporateApiRespModel>> {
    return apiMasterCorporateEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateEditPost(params?: ApiMasterCorporateEditPost$Params, context?: HttpContext): Observable<CorporateApiRespModel> {
    return this.apiMasterCorporateEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CorporateApiRespModel>): CorporateApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCorporateDeleteGet()` */
  static readonly ApiMasterCorporateDeleteGetPath = '/api/Master/Corporate/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateDeleteGet$Response(params?: ApiMasterCorporateDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Int32ApiRespModel>> {
    return apiMasterCorporateDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateDeleteGet(params?: ApiMasterCorporateDeleteGet$Params, context?: HttpContext): Observable<Int32ApiRespModel> {
    return this.apiMasterCorporateDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Int32ApiRespModel>): Int32ApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterCorporateGetAllGet()` */
  static readonly ApiMasterCorporateGetAllGetPath = '/api/Master/Corporate/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateGetAllGet$Response(params?: ApiMasterCorporateGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
    return apiMasterCorporateGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateGetAllGet(params?: ApiMasterCorporateGetAllGet$Params, context?: HttpContext): Observable<Array<Corporate>> {
    return this.apiMasterCorporateGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Corporate>>): Array<Corporate> => r.body)
    );
  }

  /** Path part for operation `apiMasterCorporateGetActiveGet()` */
  static readonly ApiMasterCorporateGetActiveGetPath = '/api/Master/Corporate/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateGetActiveGet$Response(params?: ApiMasterCorporateGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
    return apiMasterCorporateGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterCorporateGetActiveGet(params?: ApiMasterCorporateGetActiveGet$Params, context?: HttpContext): Observable<Array<Corporate>> {
    return this.apiMasterCorporateGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Corporate>>): Array<Corporate> => r.body)
    );
  }

  /** Path part for operation `apiMasterCorporateGetByCriteriaPost()` */
  static readonly ApiMasterCorporateGetByCriteriaPostPath = '/api/Master/Corporate/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterCorporateGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateGetByCriteriaPost$Response(params?: ApiMasterCorporateGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Corporate>>> {
    return apiMasterCorporateGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterCorporateGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterCorporateGetByCriteriaPost(params?: ApiMasterCorporateGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Corporate>> {
    return this.apiMasterCorporateGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Corporate>>): Array<Corporate> => r.body)
    );
  }

}
